var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-column flex-column-center login-info"},[_c('Header',{attrs:{"img":_vm.img}}),_c(_vm.currentComponent,{tag:"component",staticClass:"flex-rest"}),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }